define.alias("shared/helpers/is-present", "calendar/helpers/is-present");